import { IndexedDbStorageBackend } from './indexeddb.js';
import { defaultClock } from './model.js';
import { OpfsBlobStore } from './opfs.js';
import { createStorageProvider } from './provider.js';
function browserStorageManager() {
    if (typeof navigator === 'undefined' || !navigator.storage)
        return undefined;
    return navigator.storage;
}
export async function openIndexedDbStorage(options) {
    const clock = options.clock ?? defaultClock();
    const storageManager = options.storageManager ?? browserStorageManager();
    const backend = await IndexedDbStorageBackend.open({
        databaseName: options.databaseName,
        indexedDB: options.indexedDB,
        mode: options.mode,
        clock,
        idSource: options.idSource,
    });
    const blobs = options.blobBackend === 'indexeddb'
        ? backend.fallbackBlobs
        : new OpfsBlobStore(backend.fallbackBlobs, storageManager, clock);
    return createStorageProvider({
        mode: backend.mode,
        documents: backend.documents,
        outbox: backend.outbox,
        blobs,
        admin: backend,
        clock,
        storageManager,
    });
}
//# sourceMappingURL=factory.js.map